module.exports = __webpack_public_path__ + "img/exterior_7.2da3a54c.jpg";